module.exports = __webpack_public_path__ + "img/qianbao.78dcadb6.png";